/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Api_Errors_Vrije_Dag_Overlapt_OnbekendInputs */

const nl_planning_api_errors_vrije_dag_overlapt_onbekend = /** @type {(inputs: Planning_Api_Errors_Vrije_Dag_Overlapt_OnbekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valt al in een vakantie of vrije dag.`)
};

/**

* @param {Planning_Api_Errors_Vrije_Dag_Overlapt_OnbekendInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_api_errors_vrije_dag_overlapt_onbekend = /** @type {((inputs?: Planning_Api_Errors_Vrije_Dag_Overlapt_OnbekendInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Api_Errors_Vrije_Dag_Overlapt_OnbekendInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_api_errors_vrije_dag_overlapt_onbekend(inputs)
});
export { planning_api_errors_vrije_dag_overlapt_onbekend as "planning.api_errors.vrije_dag_overlapt_onbekend" }